export default "__VITE_ASSET__C787GqNI__"